import { render } from "./HeaderControls.vue?vue&type=template&id=53d42ed6"
import script from "./HeaderControls.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderControls.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/base/components/header-controls/HeaderControls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53d42ed6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53d42ed6', __exports__)) {
    api.reload('53d42ed6', __exports__)
  }
  
  module.hot.accept("./HeaderControls.vue?vue&type=template&id=53d42ed6", () => {
    api.rerender('53d42ed6', render)
  })

}


export default __exports__